import { setStore, getStore, removeStore } from "@/utils/mUtils";
import { setToken } from "@/utils/auth";
import { Toast } from "vant";
import { mapGetters } from "vuex";
var dsBridge = require("dsbridge");
// import { debounce } from "@/utils/debounce";
let MIXIN = {
  data() {
    // const now = new Date();
    // const future = new Date(now.getFullYear() + 3, 11, 31);
    return {
      userInfo: {},
      platform: "app",
    };
  },
  created() {
    // console.log(now);
    if (this.$route && this.$route.query.platform) {
      console.log("route中有platform");
      this.platform = this.$route.query.platform;
      setStore("platform", this.platform);
    } else if (getStore("platform")) {
      console.log("storage中有platform");
      this.platform = getStore("platform");
    }
    if (this.$route && this.$route.query.token) {
      let token = this.$route.query.token;
      setToken("Bearer " + token);
    }
  },
  computed: {
    statusBarHeight() {
      return getStore("getStatusBarHeight") || 0;
    },
  },
  mounted() {},
  methods: {
    // debounce,
    // statusBarHeight() {
    //   return getStore("getStatusBarHeight") || 0;
    // },
    // h5页面内部重置
    reduceUrl(path) {
      this.$router.replace(path);
    },
    bridgeClose(msg) {
      console.log("back - bridge");
      if (msg) {
        dsBridge.call("back", msg);
      } else {
        dsBridge.call("back");
      }
    },
    bridgeRoute(data) {
      console.log("router - bridge", data);
      dsBridge.call("route", data);
    },
    bridgeStatusBar() {
      console.log("getStatusBarHeight - bridge");
      let height = dsBridge.call("getStatusBarHeight", "占位") || 0;
      console.log("获取状态栏高度成功", height);
      setStore("getStatusBarHeight", height);
    },
    // ios禁止滚动
    iosScroll(className) {
      var startY = 0;
      var scrollBox = document.querySelector(`.${className}`);
      console.log(scrollBox);
      document.body.addEventListener(
        "touchstart",
        function(e) {
          startY = e.touches[0].pageY;
        },
        { passive: false }
      );

      document.body.addEventListener(
        "touchmove",
        function(e) {
          var moveY = e.touches[0].pageY;
          var top = scrollBox.scrollTop;
          var ch = scrollBox.clientHeight;
          var sh = scrollBox.scrollHeight;
          if (!isChildTarget(e.target, scrollBox)) {
            e.preventDefault();
          } else if (
            (top === 0 && moveY > startY) ||
            (top + ch === sh && moveY < startY)
          ) {
            e.preventDefault();
          }
        },
        { passive: false }
      );
      function isChildTarget(child, parent, justChild) {
        // justChild为true则只判断是否为子元素，若为false则判断是否为本身或者子元素 默认为false
        var parentNode;
        if (justChild) {
          parentNode = child.parentNode;
        } else {
          parentNode = child;
        }

        if (child && parent) {
          while (parentNode) {
            if (parent === parentNode) {
              return true;
            }
            parentNode = parentNode.parentNode;
          }
        }
        return false;
      }
    },
    handleVisiable(e) {
      // 监听页面离开事件
      if (e.target.visibilityState === "visible") {
        console.log("回来了,刷新列表");
        this.onRefresh();
      } else {
        console.log("离开了");
      }
    },
    onOversize(file) {
      console.log(file);
      Toast("图片大小不能超过 5M");
    },
    onVideoOversize(file) {
      console.log(file);
      Toast("上传视频限制500M，请重新选择");
    },
    // 裁剪取消
    canceltailor() {
      this.fileList = [];
    },
    // 校验图片格式
    checkImgAccept(file, typeArr) {
      console.log(file);
      let defaultTypeArr = ["jpeg", "png"];
      if (typeArr && typeArr.length > 0) {
        defaultTypeArr = defaultTypeArr.concat(typeArr);
      }
      let message = "请选择 " + defaultTypeArr.join(" 或 ") + " 格式图片";
      if (defaultTypeArr.includes(file.type.split("/")[1])) {
        return true;
      } else {
        Toast(message);
        return false;
      }
    },
    // 校验全屏状态
    checkFull() {
      var isFull =
        document.fullscreenEnabled ||
        window.fullScreen ||
        document.webkitIsFullScreen ||
        document.msFullscreenEnabled;
      if (isFull === undefined) isFull = false;
      return isFull;
    },
    // 保存未发布的评论
    saveTempMessage(level, contentId, message, reply) {
      if (level === 1) {
        setStore(`tempMessage-contentId${contentId}-0`, message);
      } else {
        setStore(`tempMessage-contentId${contentId}-${reply.id}`, message);
      }
    },
    // 获取未发布的评论
    getTempMessage(level, contentId, reply) {
      if (level === 1) {
        return getStore(`tempMessage-contentId${contentId}-0`);
      } else {
        return getStore(`tempMessage-contentId${contentId}-${reply.id}`);
      }
    },
    // 删除已发布的评论
    deleteTempMessage(level, contentId, reply) {
      // console.log(level,contentId,reply);
      if (level === 1) {
        removeStore(`tempMessage-contentId${contentId}-0`);
      } else {
        removeStore(`tempMessage-contentId${contentId}-${reply.id}`);
      }
    },
    isSignatureExpired() {
      let isExpired;
      const expireTime =
        (JSON.parse(getStore("signatureInfo")).timestamp + 7200) * 1000;
      console.log("过期时间", expireTime);
      isExpired = Date.now() >= expireTime;
      console.log("是否过期", isExpired);
      return isExpired;
    },
  },
};
export default MIXIN;
